import InputLabel from './InputLabel'

export * from './InputLabel'
export default InputLabel
